module.exports = __webpack_public_path__ + "fbe694c234fb05b0b2bbbee15a582348.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/logo.png
// module id = 744
// module chunks = 1